export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Binnacle.vue?vue&type=template&id=502239a0&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/extranet/Binnacle.vue?vue&type=template&id=502239a0&scoped=true
// module id = 1920
// module chunks = 31